import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ConfigsLoaderService } from './config-loader.service';
import {Alert, AlertCompleteStepResultDto, AlertDelete, AlertFilter, AlertFilterFlatReport, AlertList, AlertReportFilterDto, AlertsPaged, SaveAlertDto} from 'app/models/alerts/alert-list.model';
import { CreateEditAlert } from 'app/models/alerts/create-alert.interface';
import { AlertMassiveActions, AlertMassiveActionsResultDto } from 'app/models/alerts/alert-masive-actions.interface';
import { FileDownloadDto } from 'app/models/file';
import { WorkflowReviewDto } from 'app/models/workflow/workflow-step-instance.interface';
import { ReportListPaged } from 'app/models/generate-report.model';
import { ComplaintFilter, FlatComplaintFilterDto } from 'app/models/complaints/complaint-list.model';


@Injectable({
    providedIn: 'root'
})

export class AlertService {

    private readonly useMockData = false;
    private readonly apiEndpoint: string;

    constructor(
        private httpClient: HttpClient,
        private config: ConfigsLoaderService,
    ) {
        this.apiEndpoint = this.config.apiUrl;
    }

    getPaged(filter: AlertFilter): Observable<AlertsPaged> {
        if (this.useMockData) { 
            const item: AlertList = {
                selected: false,
                id: 1,
                alertCode: 12312,
                entity: 'Mock entity',
                sourceId: 'mock source',
                internalId: 'mock internal id',
                description: 'mock description',
                sourceDescription: 'mock source description',
                criticalityDescription: 'mock criticality',
                statusDescription: 'Mock Status',
                resolutionDescription: 'mock resolution',
                createdDate: new Date(),
                dueDate: new Date(),
                modifiedDate: new Date(),
                alertId: 1,
                sourceCode: "1"
            }
            const foo: AlertsPaged = {
                currentPage: 1,
                pageCount: 1,
                pageSize: 10,
                rowCount: 1,
                results: [item]
            }
            return of(foo);
        }
        return this.httpClient.post<AlertsPaged>(`${this.apiEndpoint}/Alert/getPaged`, filter);
    }

    addAlertManual(alert: CreateEditAlert): Observable<any>{
        return this.httpClient.post(`${this.apiEndpoint}/Alert/AddAlertManual`, alert);
    }

    editAlertManual(alert: CreateEditAlert): Observable<any> {
        return this.httpClient.post(`${this.apiEndpoint}/Alert/EditAlertManual`, alert);
    }

    getAlertById(id: number): Observable<Alert>{
        return this.httpClient.get<Alert>(`${this.apiEndpoint}/Alert/GetAlert/${id}`);
    }

    exportPdf(filter: AlertFilter): Observable<any>{
        return this.httpClient.post(`${this.apiEndpoint}/Alert/ExportPDF`, filter);
    }

    exportExcel(filter: AlertFilter): Observable<any> {
        return this.httpClient.post(`${this.apiEndpoint}/Alert/ExportExcel`, filter);
    }

    saveMassiveActions(data: AlertMassiveActions): Observable<AlertMassiveActionsResultDto>{
        return this.httpClient.post<AlertMassiveActionsResultDto>(`${this.apiEndpoint}/Alert/SaveMassiveActions`, data);
    }

    saveAlertProgress(alert: SaveAlertDto) {
        return this.httpClient.post(`${this.apiEndpoint}/Alert/SaveAlertProgress`, alert);
    }

    continueAlert(alertToSave: SaveAlertDto): Observable<AlertCompleteStepResultDto> {
        return this.httpClient.post<AlertCompleteStepResultDto>(`${this.apiEndpoint}/Alert/CompleteAlertStep`, alertToSave);
    }

    deleteAlert(alertDelete: AlertDelete): Observable<any> {
        return this.httpClient.delete(`${this.apiEndpoint}/Alert`, {body: alertDelete} );
    }

    downloadTemplate(): Observable<FileDownloadDto>{
        return this.httpClient.get<FileDownloadDto>(`${this.apiEndpoint}/Alert/DownloadTemplate`);
    }

    finalizeStepInstance(workflowReview: WorkflowReviewDto): Observable<WorkflowReviewDto> {
        return this.httpClient.post<WorkflowReviewDto>(`${this.apiEndpoint}/Alert/FinalizeStepInstance`, workflowReview);
    }

    generateReportAlert(generateReportFilter: AlertReportFilterDto): Observable<any> {
        return this.httpClient.post<any>(`${this.apiEndpoint}/Alert/GenerateReport`, generateReportFilter);
    }

    getAlertReportPaged(filter: any): Observable<ReportListPaged> {
        return this.httpClient.post<ReportListPaged>(`${this.apiEndpoint}/Report/GetDetail`, filter);
    }

    generateAlertFlatReport(filter: AlertFilterFlatReport): Observable<void> {
        return this.httpClient.post<void>(`${this.apiEndpoint}/Report/RequestAlertReport`, filter);
    }

    deleteFlatReport(id: number){
        return this.httpClient.post<void>(`${this.apiEndpoint}/Report/DeletedRequestReport/${id}`, id);
    }

    getAlertByUser(id: number): Observable<Alert>{
        return this.httpClient.get<Alert>(`${this.apiEndpoint}/Alert/GetAlertByUser/${id}`);
    }

    getPagedByComplaint(filter: ComplaintFilter): Observable<AlertsPaged>{
        return this.httpClient.post<AlertsPaged>(`${this.apiEndpoint}/Alert/GetPagedByComplaint`, filter);
    }

    generateAlertFlatReportByComplaint(filter: FlatComplaintFilterDto): Observable<void> {
        return this.httpClient.post<void>(`${this.apiEndpoint}/Report/RequestAlertByComplaintReport`, filter);
    }
}
